import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as OfferApiEditPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/api";
import { Route as OfferFilterEditPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/filter";
import { Route as OfferFormEditPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/form";
import { Route as OfferGeneralEditPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/general";
import { Route as OfferLinkEditPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/link";
import { Route as OfferPingTreeEditPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/pingtree";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/")({
    component: OfferEditPage,
    staticData: {
        permissions: [
            PermissionEnum.OfferEditApi,
            PermissionEnum.OfferEditIframe,
            PermissionEnum.OfferEditDefault,
            PermissionEnum.OfferEditLink,
            PermissionEnum.OfferEditCascade,
            PermissionEnum.OfferEditFilters,
        ],
        showInSideMenu: false,
        label: "pages.offer.edit.title",
        redirects: [
            OfferApiEditPage,
            OfferFormEditPage,
            OfferGeneralEditPage,
            OfferLinkEditPage,
            OfferFilterEditPage,
            OfferPingTreeEditPage,
        ],
        defaultRedirect: OfferGeneralEditPage,
    },
});
function OfferEditPage() {
    return <RedirectPage />;
}
